














import Popup from '@/views/organisms/Popup.vue'
import store from '@/store'
import BlueButton from '@/views/atoms/BlueButton.vue'

export default
  components: {
    Popup
    BlueButton
  }

  data: () ->
    disabled: false

  props:
    id:
      type: String
      default: ''
    title:
      type: String
      default: '登録してよろしいですか？'
    isPlan:
      type: Boolean
      defalt: false
    setting:
      type: Boolean
      defalt: false
    isDownload:
      type: Boolean
      defalt: false

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save: () ->
      @disabled = true
      @$emit('save')
  }
